export const ru = {
    'different-protocols': 'Разные',
    'site-link-descr': 'Описание',
    'site-link-different-values-placeholder': 'В выбранных объявлениях разные значения',
    'site-link-link': 'Ссылка на сайт',
    'site-link-placeholder': 'Заполните поле',
    'site-link-title': 'Заголовок',
    'site-link-turbo-error': 'Турбо-страница не указана или указана неверно'
};
